import { handleAction } from 'redux-actions';
import { genericError } from '../actions/errors';

const initialState = {};

const errorReducer = handleAction(genericError, {
  next(state, action) {
    return Object.assign({}, state, action.payload);
  },
  throw(state, action) {
    console.error('Unintercepted error', action.payload);
    return Object.assign({}, state, action.payload);
  }
}, initialState);

export default errorReducer;



// WEBPACK FOOTER //
// ./src/reducers/errors.js